import React from "react";
import { Col, Row } from "react-bootstrap";
import huaweiLogo1 from "../../Assets/HUAWEI -545.jpg";
import googleLogo from "../../Assets/1744813445176.jpeg";
import huaweiCert from "../../Assets/IMG_20241227_112347.jpg";
import microsoftLogo from "../../Assets/microsoftphoto.jpg";
import microsoftCert from "../../Assets/1752856550951.gif"; // تم تصحيح هذا المسار إذا كان هناك خطأ

function Awards() {
  const awards = [
    {
      logo: microsoftLogo,
      certificate: microsoftCert,
      title: "Microsoft Club Alexandria University",
      role: "President – Community Lead",
      date: "Since Julu 2025",
      points: [
        "Founded the club and built a team of 8 members across cloud, AI, and data fields.",
        "Organized 5+ technical workshops and hands-on sessions on Azure, DevOps, and security.",
        "Mentored students for Microsoft certifications and grew a local tech community.",
      ],
    },
    {
      logo: huaweiLogo1,
      certificate: huaweiCert,
      title: "Huawei Developer Competition – Northern Africa",
      role: "Team Leader – Cloud Architect",
      date: "Dec 2024",
      points: [
        "Led a 4-engineer team to build NexusFlow – an AI-driven supply-chain platform on Huawei Cloud.",
        "Architected demand forecasting & inventory optimization modules.",
        "Presented directly to Huawei MENA CEO; ranked Top 8 regionally.",
      ],
    },
    
  ];

  return (
    <>

      {awards.map((award, index) => (
        <Row
          key={index}
          className="experience-card align-items-center mb-5 p-4"
          style={{
            backgroundColor: "#1e1e2f",
            borderRadius: "20px",
            boxShadow: "0 0 20px rgba(199, 112, 240, 0.15)",
            color: "#fff",
            direction: "ltr",
          }}
        >
          <Col md={4} className="text-center mb-3">
            {/* الشعار */}
            <div
              style={{
                width: "200px",
                height: "150px",
                margin: "0 auto 15px auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#fff",
                borderRadius: "12px",
                overflow: "hidden",
              }}
            >
              <img
                src={award.logo}
                alt={`${award.title} logo`}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />
            </div>

            {/* الشهادة */}
            <div
              style={{
                width: "200px",
                height: "150px",
                margin: "0 auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#fff",
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0 0 12px rgba(199, 112, 240, 0.2)",
              }}
            >
              {award.certificate ? (
                <img
                  src={award.certificate}
                  alt={`${award.title} certificate`}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              ) : (
                <span style={{ color: "#333", fontSize: "0.9rem" }}>No Certificate</span>
              )}
            </div>
          </Col>

          <Col md={8}>
            <h4 style={{ color: "#c770f0", fontWeight: "bold" }}>{award.title}</h4>
            <h5 className="mb-2" style={{ fontSize: "1.1rem" }}>{award.role}</h5>
            <p className="text-muted mb-3">{award.date}</p>
            <ul style={{ fontSize: "1rem", paddingLeft: "20px", textAlign: "left" }}>
              {award.points.map((point, idx) => (
                <li key={idx} style={{ marginBottom: "8px" }}>{point}</li>
              ))}
            </ul>
          </Col>
        </Row>
      ))}
    </>
  );
}

export default Awards;